<template>
  <header>
    <div class="headerInner">
      <h1><a href="/"><img src="../assets/images/logo.svg" alt="九州離島図鑑"></a></h1>
      <a href="#island"><img src="../assets/images/search.svg" alt=""></a>
      <!--
      <nav class="headerNav">
        <ul>
          <li><a href="../"><img src="../assets/images/search.svg"></a></li>
          <li><a href="">地図</a></li>
          <li><a href="">アクセス</a></li>
          <li><a href="">基本情報</a></li>
        </ul>
      </nav>
      -->
    </div>
  </header>

  <section id="island-name">
    <div>
      <h1><span>{{ islandDetail.prefecture }}</span>{{ islandDetail.name }}<span>{{ islandDetail.name_en }}</span></h1>
    </div>
  </section>

  <section>
    <swiper-view :island-detail="islandDetail"></swiper-view>
  </section>

  <p class="page-link" v-if="islandDetail.article"><a :href="islandDetail.article"><span>{{ islandDetail.name }}</span>の記事ページはこちら</a></p>

  <main>
    <section id="map-section">
      <div class="content">
        <map-and-place :island-detail="islandDetail"></map-and-place>
      </div>
    </section>

    <section id="information">
      <div class="content">
        <h2 class="title">基本情報</h2>
        <table>
          <tbody>
            <tr>
              <th>住所</th>
              <td><span id="address">{{ islandDetail.address }}</span></td>
            </tr>
            <tr>
              <th>人口</th>
              <td><span id="population">{{ islandDetail.population }}</span></td>
            </tr>
            <tr>
              <th>面積</th>
              <td>
                <div v-if="islandDetail.area"><span id="area">{{ islandDetail.area }}</span>km²</div>
              </td>
            </tr>
            <tr>
              <th>アクセス</th>
              <td><span id="routes">{{ islandDetail.access }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!--
    <section id="enjoy-point" v-if="((islandDetail.description && islandDetail.description.length > 0 ) || ( islandDetail.tabinets && islandDetail.tabinets.length > 0 ))">
    -->
    <section id="enjoy-point">
      <div class="content">
        <h2 class="title">満喫ポイント</h2>
        <p>{{ islandDetail.description }}</p>
      </div>
      <div class="content" v-if="islandDetail.tabinets && islandDetail.tabinets.length > 0">
        <h2 class="title">九州旅ネットによる紹介</h2>
        <p v-for="(tabinet, index) in islandDetail.tabinets" :key="index" class="button">
          <a :href="tabinet.url" target="_blank">{{ tabinet.title }}</a>
        </p>
      </div>
    </section>

    <!--
    <section id="useful-information">
      <div class="content">
        <h2 class="title">有用な情報</h2>
        <div id="useful-info" class="list">
          <div class="item">
            <h3>交通情報</h3>
            <p class="rating">壱岐島へは博多港や唐津港からフェリーでアクセスできます。</p>
          </div>
          <div class="item">
            <h3>天気情報</h3>
            <p class="rating">壱岐の天気を確認するには、最新の気象情報をチェックしてください。</p>
          </div>
        </div>
      </div>
    </section>
  -->

  </main>
  <section id="island">
    <p class="cover"><img src="../assets/images/island-cover.svg" alt=""></p>
    <div class="island-overview">
      <div>
        <h2>九州の島々に出会う旅</h2>
        <p>
          約3,900もの島々が点在する九州には、離島ならではの宿やグルメ、自然を満喫できるアクティビティが待っています。<br>自然と共存する知恵と工夫がなされた文化と伝統が息づく島々では、昔ながらの技術で作られたお菓子や郷土料理を味わうことができ、心も体も癒されるひとときが過ごせます。<br>美しい景色と島の穏やかな時間に包まれながら、日常を忘れて心からリフレッシュする旅へと、一歩踏み出してみませんか？
        </p>
      </div>
      <MainMapComponent />
      <!--
      <img src="../assets/images/islands.png" alt="">
      -->
    </div>
    <div class="island-search">
      <div :class="{ inactive: selectedRegion !== 'search' }" @click="selectRegion('search')">
        <a href="javascript:void(0);">
          <img src="../assets/images/island-search.svg" alt="">
        </a>
      </div>
      <ul>
        <li class="fukuoka" :class="{ inactive: selectedRegion !== 'fukuoka' }" @click="selectRegion('fukuoka')">
          <a href="javascript:void(0);">福岡県</a>
        </li>
        <li class="saga" :class="{ inactive: selectedRegion !== 'saga' }" @click="selectRegion('saga')">
          <a href="javascript:void(0);">佐賀県</a>
        </li>
        <li class="nagasaki" :class="{ inactive: selectedRegion !== 'nagasaki' }" @click="selectRegion('nagasaki')">
          <a href="javascript:void(0);">長崎県</a>
        </li>
        <li class="kumamoto" :class="{ inactive: selectedRegion !== 'kumamoto' }" @click="selectRegion('kumamoto')">
          <a href="javascript:void(0);">熊本県</a>
        </li>
        <li class="oita" :class="{ inactive: selectedRegion !== 'oita' }" @click="selectRegion('oita')">
          <a href="javascript:void(0);">大分県</a>
        </li>
        <li class="miyazaki" :class="{ inactive: selectedRegion !== 'miyazaki' }" @click="selectRegion('miyazaki')">
          <a href="javascript:void(0);">宮崎県</a>
        </li>
        <li class="kagoshima" :class="{ inactive: selectedRegion !== 'kagoshima' }" @click="selectRegion('kagoshima')">
          <a href="javascript:void(0);">鹿児島県</a>
        </li>
      </ul>
    </div>
    <div class="search-result">
      <div class="result-container fukuoka" v-show="selectedRegion === 'fukuoka'">
        <div>
          <p>福岡県</p>
          <ul>
            <li><a href="./oshima_muna">大島</a></li>
            <li><a href="./okinoshima">沖ノ島</a></li>
            <li><a href="./ainoshima_kita">藍島</a></li>
            <li><a href="./jinoshima">地島</a></li>
            <li><a href="./ainoshima_fuku">相島</a></li>
            <li><a href="./shikanoshima">志賀島</a></li>
            <li><a href="./nokonoshima">能古島</a></li>
            <li><a href="./oronoshima">小呂島</a></li>
            <li><a href="./genkaijima">玄界島</a></li>
            <li><a href="./himeshima_ito">姫島</a></li>
          </ul>
        </div>
      </div>

      <div class="result-container saga" v-show="selectedRegion === 'saga'">
        <div>
          <p>佐賀県</p>
          <ul>
            <li><a href="./takashima_karatsu">高島</a></li>
            <li><a href="./kabeshima">加部島</a></li>
            <li><a href="./kakarashima">加唐島</a></li>
            <li><a href="./madarashima">馬渡島</a></li>
            <li><a href="./kashiwajima">神集島</a></li>
            <li><a href="./ogawashima">小川島</a></li>
            <li><a href="./matsushima_karatsu">松島</a></li>
            <li><a href="./mukushima">向島</a></li>
          </ul>
        </div>
      </div>

      <div class="result-container nagasaki" v-show="selectedRegion === 'nagasaki'">
        <div>
          <p>長崎県</p>
          <ul>
            <li><a href="./iki">壱岐島</a></li>
            <li><a href="./takushima">度島</a></li>
            <li><a href="./aduchioshima">的山大島</a></li>
            <li><a href="./tsushima">対馬</a></li>
            <li><a href="./takashima_matsuura">鷹島</a></li>
            <li><a href="./hiradoshima">平戸島</a></li>
            <li><a href="./ikitsukijima">生月島</a></li>
            <li><a href="./takashima_sasebo">高島</a></li>
            <li><a href="./oshima_sasebo">大島</a></li>
            <li><a href="./terashima">寺島</a></li>
            <li><a href="./sakitojima">崎戸島</a></li>
            <li><a href="./hirashima">平島</a></li>
            <li><a href="./matsushima_saikai">松島</a></li>
            <li><a href="./ioujima_naga">伊王島</a></li>
            <li><a href="./takashima_naga">高島</a></li>
            <li><a href="./makishima_naga">牧島</a></li>
            <li><a href="./ojikajima">小値賀島</a></li>
            <li><a href="./nakadorijima">中通島</a></li>
            <li><a href="./kirinokojima">桐ノ小島</a></li>
            <li><a href="./fukuejima">福江島</a></li>
            <li><a href="./unijima">海栗島</a></li>
            <li><a href="./fukushima">福島</a></li>
            <li><a href="./aoshima">青島</a></li>
            <li><a href="./maejima_goto">前島</a></li>
            <li><a href="./kuroshima_sasebo">黒島</a></li>
            <!--
            <li><a href="./hariojima">針尾島</a></li>
            -->
            <li><a href="./toudomarijima">鼕泊島</a></li>
            <li><a href="./oshima_saikai">大島</a></li>
            <li><a href="./kakinourashima">蠣浦島</a></li>
            <li><a href="./ikeshima">池島</a></li>
            <li><a href="./kabashima">樺島</a></li>
            <li><a href="./ukujima">宇久島</a></li>
            <li><a href="./madarajima">斑島</a></li>
            <li><a href="./wakamatsujima">若松島</a></li>
            <li><a href="./arifukujima">有福島</a></li>
            <li><a href="./narushima">奈留島</a></li>
            <li><a href="./hisakajima">久賀島</a></li>
          </ul>
        </div>
      </div>

      <div class="result-container kumamoto" v-show="selectedRegion === 'kumamoto'">
        <div>
          <p>熊本県</p>
          <ul>
            <li><a href="./goshourajima">御所浦島</a></li>
            <li><a href="./tobasejima">戸馳島</a></li>
            <li><a href="./iwajima">維和島</a></li>
            <li><a href="./oyanojima">大矢野島</a></li>
            <li><a href="./yushima">湯島</a></li>
            <li><a href="./nagaurajima">永浦島</a></li>
            <li><a href="./maejima_kamiama">前島</a></li>
            <li><a href="./amakusakamishima">天草上島</a></li>
            <li><a href="./nogamajima">野釜島</a></li>
            <li><a href="./hiaijima">樋合島</a></li>
            <li><a href="./hinoshima">樋島</a></li>
            <li><a href="./yokourajima">横浦島</a></li>
            <li><a href="./tsujishima">通詞島</a></li>
            <li><a href="./gesushima">下須島</a></li>
            <li><a href="./makishima_amakusa">牧島</a></li>
            <li><a href="./amakusashimoshima">天草下島</a></li>
          </ul>
        </div>
      </div>

      <div class="result-container oita" v-show="selectedRegion === 'oita'">
        <div>
          <p>大分県</p>
          <ul>
            <li><a href="">黒島</a></li>
            <li><a href="">保戸島</a></li>
            <li><a href="">地無垢島</a></li>
            <li><a href="">大入島</a></li>
            <li><a href="">屋形島</a></li>
            <li><a href="">大島</a></li>
            <li><a href="">深島</a></li>
          </ul>
        </div>
      </div>

      <div class="result-container miyazaki" v-show="selectedRegion === 'miyazaki'">
        <div>
          <p>宮崎県</p>
          <ul>
            <li><a href="./shimanourashima">島野浦島</a></li>
            <li><a href="./oshima_nichi">大島</a></li>
            <li><a href="./tsukishima">築島</a></li>
          </ul>
        </div>
      </div>

      <div class="result-container kagoshima" v-show="selectedRegion === 'kagoshima'">
        <div>
          <p>鹿児島県</p>
          <ul>
            <li><a href="./yakushima">屋久島</a></li>
            <li><a href="./koshikishima">甑島</a></li>
            <li><a href="./shishijima">獅子島</a></li>
            <li><a href="./ikarajima">伊唐島</a></li>
            <li><a href="./shorajima">諸浦島</a></li>
            <li><a href="./nagashima">長島</a></li>
            <li><a href="./tanegashima">種子島</a></li>
            <li><a href="./kuchinoerabujima">口永良部島</a></li>
            <li><a href="./ioujima_kago">硫黄島</a></li>
            <li><a href="./kuroshima_mishima">黒島</a></li>
            <li><a href="./kuchinoshima">口之島</a></li>
            <li><a href="./nakanoshima">中之島</a></li>
            <li><a href="./takarajima">宝島</a></li>
            <li><a href="./amamioshima">奄美大島</a></li>
            <li><a href="./kakeromajima">加計呂麻島</a></li>
            <li><a href="./kikaijima">喜界島</a></li>
            <li><a href="./tokunoshima">徳之島</a></li>
            <li><a href="./okinoerabujima">沖永良部島</a></li>
            <li><a href="./yoronjima">与論島</a></li>
          </ul>
        </div>
      </div>
      <div class="search-container search" v-show="selectedRegion === 'search'">
        <div>
          <SearchComponent/>
        </div>
      </div>
    </div>
  </section>
  <footer>
    <p><a href=""><img src="../assets/images/logo-w.svg" alt=""></a></p>
    <!--
    <ul>
      <li><a href="">組織概要・当サイトについて</a></li>
      <li><a href="">リンク集</a></li>
      <li><a href="">お問い合わせ・資料請求</a></li>
    </ul>
    -->
  </footer>
</template>

<style src="../styles/index.css"></style>
<style src="../styles/reset.css"></style>
<style src="../styles/islanddetail.css"></style>
<script>
// import island from '@/store/modules/island';
import MapAndPlace from './MapAndPlace2.vue';
import SwiperView from './SwiperView.vue';
import MainMapComponent from '../components/MainMap.vue';
import SearchComponent from '../components/SearchComp.vue';
import { base } from '@/router/index.js'
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    MapAndPlace,
    SwiperView,
    MainMapComponent,
    SearchComponent
  },
  data() {
    return {
      routerBase: base,
      selectedRegion: 'fukuoka',
    };
  },
  computed: {
    ...mapState('island', {
      islandDetails: (state) => state.islandDetails
    }),
    // ...mapGetters('island', ['base', 'islandDetails']),  // Vuexからbaseを取得
    currentPath() {
      return this.$route.path;  // 現在のパスを返す
    },
    islandDetail() {
      // console.log("IslandDetailView computed: islandDetail() this.$route.name = " + this.$route.name);
      // console.log("IslandDetailView computed: islandDetail() return islandDetails key size = " + Object.keys(this.islandDetails));
      // console.log("IslandDetailView computed: islandDetail() key exists islandDetails = " + ( this.$route.name in this.islandDetails));
      return this.islandDetails[this.$route.name] || {};  // 現在の島の詳細情報を取得
    }
  },
  watch: {
    // ルート情報が変更されたときに実行
    '$route'(newRoute) {
      // console.log("IslandDetailView watch newRoute = " + newRoute);
      const newIslandName = newRoute.name;
      // console.log("IslandDetailView watch newRoute.name = " + newIslandName);

      // データが存在しない場合に取得、既にある場合はそのまま更新
      // console.log("IslandDetailView watch  this.islandDetails[newIslandName] = " + this.islandDetails[newIslandName]);
      if (!this.islandDetails[newIslandName]) {
        // console.log("IslandDetailView watch 01");
        this.fetchIslandDetail(newIslandName);
      } else {
        // console.log("IslandDetailView watch 02");
        this.islandDetail = this.islandDetails[newIslandName];
      }
      // this.fetchData(newRoute.name);
      // this.fetchIslandDetail(newRoute.name);
    },
    // islandDetail の変更を監視
    islandDetail: {
      handler(newValue) {
        if (newValue && newValue.prefecture) {
          this.updateSelectedRegion(newValue.prefecture);
        }
      },
      immediate: true, // 初期読み込み時にも実行
      deep: true       // オブジェクトの深い変更を監視
    }
  },
  // '$route.name'(newIslandName) {
  //     if (!this.islandDetails[newIslandName]) {
  //       this.fetchIslandDetail(newIslandName);
  //     } else {
  //       this.islandDetail = this.islandDetails[newIslandName]; // データが既にある場合にも更新
  //     }
  //   },
  beforeMount() {
    // コンポーネントがDOMにマウントされる直前にデータを読み込む
    if (this.$route.name) {
      // console.log("IslandDetailView beforeMount() this.$route.name = " + this.$route.name);
      this.fetchIslandDetail(this.$route.name);
    } else {
      // console.error("IslandDetailView beforeMount() this.$route.name is undefined.");
    }
  },
  mounted() {
    if (this.$route.name) {
      // console.log("IslandDetailView mounted() this.$route.name = " + this.$route.name);
      this.fetchIslandDetail(this.$route.name);
    } else {
      console.error("IslandDetailView mounted() this.$route.name is undefined.");
    }
  },
  // created() {
  // コンポーネント作成時にデータを読み込む
  // this.fetchData(this.$route.name);
  // コンポーネント作成時にデータを読み込む
  // console.log("IslandDetailView created() this.$route.name = " + this.$route.name);
  // this.fetchIslandDetail(this.$route.name);
  // },
  methods: {
    ...mapActions('island', ['fetchIslandDetails']),  // fetchIslandDetailsアクションをマッピング
    fetchIslandDetail(islandName) {
      // if (!this.islandDetails[islandName]) {
      //   this.fetchIslandDetails(islandName);
      // }
      this.fetchIslandDetails(islandName).then(() => {
        console.log("IslandDetailView fetchIslandDetail().then() islandName = " + islandName);
        // console.log("IslandDetailView fetchIslandDetail().then() islandDetail = " + this.islandDetails[islandName]);
        // this.islandDetail = this.islandDetails[islandName];
      }).catch(error => {
        console.error('IslandDetailView fetchIslandDetail() Error fetching island detail:', error);
      });
    },
    formatPopulation(value) {
      if (value === undefined || value === null) {
        return '';  // 値が存在しない場合のデフォルト表示
      }
      return value.toLocaleString();
    },
    selectRegion(region) {
      this.selectedRegion = region;
    },
    updateSelectedRegion(prefecture) {
      // 県名を selectedRegion のキーにマッピング
      const regionMap = {
        '福岡県': 'fukuoka',
        '佐賀県': 'saga',
        '長崎県': 'nagasaki',
        '熊本県': 'kumamoto',
        '大分県': 'oita',
        '宮崎県': 'miyazaki',
        '鹿児島県': 'kagoshima'
      };
      const regionKey = regionMap[prefecture];
      if (regionKey) {
        this.selectedRegion = regionKey;
      } else {
        // 県名がマッピングにない場合のデフォルト値を設定
        this.selectedRegion = 'fukuoka'; // デフォルト値
      }
    },
    /*
    async fetchData(fileName) {
      console.log("IslandDetailView fetchData() fileName = " + fileName);
      const response = await fetch(`./pub/data/${fileName}.json`);
      if (response.ok) {
        this.item = await response.json();
        console.log("IslandDetailView fetchData() this.item = " + JSON.stringify(this.item));
      } else {
        console.error("Failed to fetch data:", response.statusText);
      }
    }
    */
  }
}
</script>